var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{on:{"click":_vm.modalClick}},[_vm._v("Launch demo modal 7c81febf")]),_c('b-modal',{attrs:{"id":"modal-1","title":"BootstrapVue"},on:{"ok":_vm.increaseCount}},[_c('p',{staticClass:"my-4"},[_vm._v("Hello from modal! "+_vm._s(_vm.clickCount))])]),_vm._v(" "+_vm._s(_vm.clickCount)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }